import { Box } from "@mui/material";
import { motion } from "motion/react";

export default function Particle({
  index,
  numberRect,
  modalRect,
}: {
  index: number;
  numberRect: DOMRect | null;
  modalRect: DOMRect | null;
}) {
  const colors = ["#9147ff", "#3f137c", "#b366ff", "#7c3aed", "#a855f7"];
  const color = colors[index % colors.length];
  const size = index % 4 === 0 ? 6 : 4;

  const angle = (index / 16) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
  const distance = 60 + Math.random() * 40;
  const targetX = Math.cos(angle) * distance;
  const targetY = Math.sin(angle) * distance;

  // Calculate relative position within modal
  let startX = 0;
  let startY = 0;

  if (numberRect && modalRect) {
    // Position relative to modal container
    startX = numberRect.left + numberRect.width / 2 - modalRect.left;
    startY = numberRect.top + numberRect.height / 2 - modalRect.top;
  }

  return (
    <Box
      component={motion.div}
      sx={{
        position: "absolute",
        borderRadius: "50%",
        pointerEvents: "none",
        zIndex: 999,
        backgroundColor: color,
        width: size,
        height: size,
        left: startX,
        top: startY,
        boxShadow: `0 0 ${size * 2}px ${color}40`,
      }}
      initial={{ scale: 0, opacity: 0, x: 0, y: 0 }}
      animate={{
        x: targetX,
        y: targetY,
        scale: [0, 1.2, 0.8, 0],
        opacity: [0, 1, 0.8, 0],
        rotate: size === 6 ? 360 : 180,
      }}
      transition={{
        duration: size === 6 ? 2.0 : 1.4,
        delay: index * 0.05,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
    />
  );
}
